import { useRef, useCallback, useEffect } from 'react';
import { useVirtual } from 'react-virtual';
const useVirtualizedHelpers = _ref => {
  let {
    menuItems,
    isGroupHeader,
    isOpen
  } = _ref;
  const parentRef = useRef(null);
  const rowVirtualizer = useVirtual({
    size: menuItems.length,
    parentRef,
    overscan: 10,
    estimateSize: useCallback(index => {
      const item = menuItems[index];
      return isGroupHeader(item) ? item.label ? 32 : 0 : item.subtext ? 56 : 36;
    }, [menuItems, isGroupHeader])
  });
  useEffect(() => {
    if (!isOpen) {
      rowVirtualizer.scrollToOffset(0);
    }
  }, [isOpen, rowVirtualizer]);
  return {
    parentRef,
    rowVirtualizer
  };
};
export default useVirtualizedHelpers;
//# sourceMappingURL=useVirtualizedHelpers.js.map